import LeaveItem from "components/Screens/Timeoff/ManageTimeoff/Customer/LeavesList/LeaveItem/index";

import { convertDate, formatDateMMMDDYYYY } from "components/Screens/CommonUtils";

import "./LeaveList.css";

function LeaveList({ selectedDateRange, employeesTimeout = [] }) {
  return (
    <>
      <div className="flex">
        {/* TODO: Implement functionality in phase 2 timeoff */}

        {/* <div className="upcoming-leaves-range-label-wrapper">
          <img src={Chevron} className="upcoming-leaves-chevron-left" alt="chevron" />
          <div className="upcoming-leaves-range-label ">Previous</div>
        </div>

        <div className="upcoming-leaves-range-label-wrapper upcoming-leaves-range-right">
          <div className="upcoming-leaves-range-label">Upcoming</div>
          <img src={Chevron} className="upcoming-leaves-chevron-right" alt="chevron" />
        </div> */}

        <div className="flex gap-05 calendar-dot-indicator-wrapper">
          <span className="align-self-center calendar-dot-indicator-orange" />

          <p className="para-body-s-regular align-self-center">Leaves</p>

          <span className="align-self-center calendar-dot-indicator-green" />

          <p className="para-body-s-regular align-self-center">Holidays</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="rectangle rectangle-multiple mr-1" />
        <div>
          <p className="heading-h4-semibold" id="date-range-selected">
            {formatDateMMMDDYYYY(selectedDateRange?.startDate)}{" "}
            {convertDate(selectedDateRange?.startDate) !== convertDate(selectedDateRange?.endDate) &&
              ` - ${formatDateMMMDDYYYY(selectedDateRange?.endDate)}`}
          </p>
          <p className="para-body-s-regular " id="people-out-from-office">
            People out this day : {employeesTimeout?.length}
          </p>
        </div>
      </div>
      {employeesTimeout.length > 0 ? (
        <div className="mt-1 space-y-1">
          {employeesTimeout?.map((emp) => (
            <span>
              <LeaveItem emp={emp} />
            </span>
          ))}
        </div>
      ) : (
        <div
          style={{
            borderRadius: "12px",
            marginTop: "1rem",
            background: "#FBFAFF",
          }}
        >
          <p
            style={{
              fontFamily: "Poppins-Regular",
              color: "#989AD1",
              padding: "2rem 3.5rem",
              margin: "auto",
            }}
            className="para-body-s-medium color-text-body-primary"
          >
            No Employees out today
          </p>
        </div>
      )}
    </>
  );
}

export default LeaveList;
